<tui-push *tuiPush="open" [type]="'Warning' | translate" (close)="toggle(false)">
  {{ 'Your account will be blocked' | translate }}:
  <b>{{ blockingAccountDate | customDate }}</b>
  <tui-icon [style.border-width.rem]="0.25" icon="@tui.warning" />
</tui-push>
